var $ = require('jquery');

"use strict";

var PLUGIN_NAME = "pageloader";

var DEFAULTS = {
	animationSpeed: {
		hide: 500,
		show: 700
	},
	urlSuffix: '/index.shtml',
	eventPrefix: 'PAGELOADER',
	callback: function() {

	}
};

/**
 *
 * @param element
 * @param options
 * @constructor
 */
var PageLoader = function(element, options) {
	this.element = element;
	this.$t = $(this.element);

	this.historySupported = 'pushState' in history;

	this.options = $.extend(true, {}, DEFAULTS, options);

	this._defaults = DEFAULTS;

	this.saveHistory_(window.location.pathname, document.title, true);

	this.bindEvents_();
};

PageLoader.prototype.bindEvents_ = function() {
	var self_ = this;

	/**
	 * triggers after content is loaded, rendered and revealed
	 */
	this.$t.on(self_.options.eventPrefix + '_COMPLETE', function(event, url, title, saveHistory) {

		if ($.isFunction(self_.options.callback)) {
			self_.options.callback.call(self_);
		}

		if (saveHistory) {
			self_.saveHistory_(url, title);
		} else {
			document.title = title;
		}
	});

	/**
	 * history popstate
	 */
	$(window).on('popstate.pageloader', function() {
		self_.$t.trigger(self_.options.eventPrefix + '_HISTORY_POPPED');
	});


};

/**
 *
 * @param url
 * @param selector
 * @param title
 * @param saveHistory
 */
PageLoader.prototype.loadPage = function(url, selector, title, saveHistory) {
	var self_ = this;

	this.$t.animate(
		{
			opacity: 0
		},
		this.options.animationSpeed.hide,
		function() {
			self_.$t.load(
				url + self_.options.urlSuffix + ' ' + selector,
				function() {
					self_.$t.animate(
						{
							opacity: 1
						},
						self_.options.animationSpeed.show,
						function() {
							self_.$t.trigger(self_.options.eventPrefix + '_COMPLETE', [url, title, saveHistory]);
						}
					);
				}
			);
		}
	);
};

/**
 *
 * @param url
 * @param title
 * @param init
 * @returns {boolean}
 * @private
 */
PageLoader.prototype.saveHistory_ = function(url, title, init) {
	if (!this.historySupported) {
		return false;
	}

	var state = history.state || {};
	state.contentUrl = url;
	state.pageTitle = title;

	if (init) {
		history.replaceState(state, title, window.location.origin + url);
	} else {
		history.pushState(state, title, window.location.origin + url);
		document.title = title;
	}

	this.$t.trigger(this.options.eventPrefix + '_HISTORY_SAVED', [url, title]);
};

module.exports=PageLoader;


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/pageloader.js